import { Drawer, DrawerProps } from "@mui/material";
import { cloneElement } from "react";
import { DetailsView } from "../details/DetailsView";
import { TabView } from "./TabView";
import { MainMenu } from "../../constants/options";
import { RenderNavMenu } from "../../utils/menuUtils";
import { MethodPicker } from "./MethodPicker";

/**
 * MobileMenu: renders the same content as LeftMenu but WITHOUT
 * the position:fixed / display:none CSS that hides it on mobile.
 */
const MobileMenu = ({ dismiss }: { dismiss?: () => void }) => {
  return (
    <div
      className="whiteBg y100 scroll"
      style={{
        width: 260,
        overflowY: "auto",
        height: "100%",
        padding: 10,
      }}
    >
      <div className="p10 flexColumn gap10">
        <RenderNavMenu menu={MainMenu()} />
      </div>
    </div>
  );
};

export const DrawerView = ({
  anchor,
  show,
  dismiss,
  component,
  componentProps,
}: {
  anchor?: DrawerProps["anchor"];
  show: boolean;
  dismiss: any;
  component?: string | any;
  [key: string]: any;
}) => {
  const handleClose = () => {
    if (dismiss) return dismiss();
  };

  const renderChildren = () => {
    if (!component) return null;

    const Component = drawerComponents[component];
    if (!Component) return null;

    try {
      return cloneElement(<Component />, { dismiss, ...componentProps });
    } catch (err) {
      console.error(`[DrawerView] Error rendering "${component}":`, err);
      return null;
    }
  };

  return (
    <Drawer
      anchor={anchor}
      open={show}
      keepMounted
      onClose={handleClose}
      sx={{
        "& .MuiDrawer-paper": {
          borderRadius: anchor === "bottom" ? "16px 16px 0 0" : 0,
        },
      }}
    >
      {renderChildren()}
    </Drawer>
  );
};

export const drawerComponents: any = {
  mobile: MobileMenu,
  details: DetailsView,
  tabs: TabView,
  method_picker: MethodPicker,
};